import { render, staticRenderFns } from "./PontoExcecao.vue?vue&type=template&id=110d8088"
import script from "./PontoExcecao.vue?vue&type=script&lang=js"
export * from "./PontoExcecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports